import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { teamsQueryKeys } from "./queryKeyFactory";

type UpdateTeamMembersPayload = {
    teamId: number;
    userIds: number[];
};

export const useUpdateTeamMembersMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateTeamMembersPayload>({
        mutationFn: ({ teamId, userIds }) => salesApiService.teams.updateTeamMembers(teamId, { userIds }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
